import { render, staticRenderFns } from "./sertificates-ca.vue?vue&type=template&id=9b3f4d5c&scoped=true"
import script from "./sertificates-ca.vue?vue&type=script&lang=ts"
export * from "./sertificates-ca.vue?vue&type=script&lang=ts"
import style0 from "./sertificates-ca.vue?vue&type=style&index=0&id=9b3f4d5c&prod&lang=css&scoped=true"
import style1 from "./sertificates-ca.vue?vue&type=style&index=1&id=9b3f4d5c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3f4d5c",
  null
  
)

export default component.exports